import React from 'react';
import { CardDescription, PaddedContainer } from './styled';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import CardLogo from '../CardLogo';
import { ACCOUNT_TYPE } from '../../constants/PaymentTypes';
export var MopDisplayContent = function MopDisplayContent(props) {
  var _props$mop = props.mop,
    type = _props$mop.type,
    accountType = _props$mop.accountType,
    description = _props$mop.description,
    last4 = _props$mop.last4,
    month = _props$mop.month,
    year = _props$mop.year,
    billingAddress = _props$mop.billingAddress,
    ariaDescribedById = props.ariaDescribedById,
    withoutCardholderName = props.withoutCardholderName;
  var creditCardTextDataTest = "".concat(DataTestAttributes.EXISTING_CARD_DESCRIPTION, "-").concat(last4);
  var withoutCardholderNameText = "*".concat(last4, " - Exp. ").concat(month, "/").concat(year === null || year === void 0 ? void 0 : year.substr(2));
  var cardHolderDescription = function cardHolderDescription() {
    if (accountType === ACCOUNT_TYPE.VENMO) {
      return billingAddress.fname;
    } else if (withoutCardholderName) {
      return withoutCardholderNameText;
    } else {
      return description;
    }
  };
  var getCardType = function getCardType() {
    if (accountType == ACCOUNT_TYPE.GOOGLE_PAY) {
      return accountType;
    }
    return type || accountType;
  };
  var cardInfo = cardHolderDescription();
  return /*#__PURE__*/React.createElement(PaddedContainer, null, /*#__PURE__*/React.createElement(CardLogo, {
    cardType: getCardType(),
    valid: true,
    dataTest: 'card logo',
    id: ariaDescribedById && "logo:".concat(ariaDescribedById),
    isMopContainer: true
  }), /*#__PURE__*/React.createElement(CardDescription, {
    id: ariaDescribedById && "description:".concat(ariaDescribedById),
    title: cardInfo,
    "data-test": "".concat(last4 ? creditCardTextDataTest : DataTestAttributes.EXISTING_MOP_TEXT)
  }, cardInfo));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/MopDisplayContent/index.js
// module id = 661
// module chunks = 11